<button class="bar-item"
        type="button"
        mat-flat-button>
  <mat-icon [matBadge]="(badgeValue === 0 ? null: badgeValue)"
            [matBadgeColor]="badgeColor || 'accent'"
            matBadgeSize="small"
            [svgIcon]="svgIcon">{{icon}}</mat-icon>
</button>
